import request from '../../utils/request';
import { Result } from '@/models/general';
import {
  WorkPointRuleView,
  WorkPointEstimateView,
  WorkPointBreakdownView,
  CompensationReportView,
  PayrollEntriesResultView,
  CreateWorkPointRuleInput,
  UpdateWorkPointRuleInput,
  WorkPointEstimateQuery,
  CompensationReportQuery,
} from '@/models/tournament';

export async function getCalculationRules() {
  const response = await request.get<Result<WorkPointRuleView[]>>('WorkPoint/GetCalculationRules');
  return response.data;
}

export async function getActiveRule() {
  const response = await request.get<Result<WorkPointRuleView>>('WorkPoint/GetActiveRule');
  return response.data;
}

export async function createRule(input: CreateWorkPointRuleInput) {
  const response = await request.post<Result<WorkPointRuleView>>('WorkPoint/CreateRule', input);
  return response.data;
}

export async function updateRule(input: UpdateWorkPointRuleInput) {
  const response = await request.put<Result<WorkPointRuleView>>('WorkPoint/UpdateRule', input);
  return response.data;
}

export async function estimatePoints(query: WorkPointEstimateQuery) {
  const response = await request.get<Result<WorkPointEstimateView>>('WorkPoint/EstimatePoints', { params: query });
  return response.data;
}

export async function getMatchBreakdown(matchId: number) {
  const response = await request.get<Result<WorkPointBreakdownView[]>>(`WorkPoint/GetMatchBreakdown/${matchId}`);
  return response.data;
}

export async function getCompensationReport(query: CompensationReportQuery) {
  const response = await request.get<Result<CompensationReportView>>('WorkPoint/GetCompensationReport', { params: query });
  return response.data;
}

export async function recalculateMatch(matchId: number) {
  const response = await request.post<Result<WorkPointBreakdownView[]>>(`WorkPoint/RecalculateMatch/${matchId}`);
  return response.data;
}

export async function generatePayrollEntries(input: { startDate: string; endDate: string; tournamentId?: number; refereeUserId?: string }) {
  const response = await request.post<Result<PayrollEntriesResultView>>('WorkPoint/GeneratePayrollEntries', input);
  return response.data;
}
